import { gql } from '@apollo/client';

export const GET_WORKSPACE_SUBMISSION = gql`
  query getWorkspaceSubmission($id: ID) {
    submission: getWorkspaceSubmission(id: $id) {
      id
      workspaceForm {
        template {
          jsonData
        }
      }
      data {
        id
        question {
          id
          title
          name
          tag
        }
        answer
      }
      userRespondent {
        id
        firstName
        lastName
      }
      status
    }
  }
`;
